import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import SideSearchbar from '../../components/SideSearchbar/'
import { GetCategories, GetAccessRights, EditCategories, CreateCategories, DeleteCategory } from './categoriesAction'
import {
  DialogContentText, DialogContent, DialogTitle, DialogActions, Dialog,
  Container, Grid, Button, TextField,
  TableContainer,
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  FormControlLabel,
  RadioGroup,
  Radio,
  Paper
} from '@material-ui/core';
import {
  Prompt
} from "react-router-dom";
import './style.css'
import isEmpty from 'lodash.isempty';
import OverLoader from '../../components/common/loader';
import { LogoutAction } from '../../actions';

class UserCategories extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isDeleteContactDialogOpen: false,
      isUpdateAccessDialog: false,
      accessErrorDialog: false,
      editMode: false,
      useRadioButton: false,
      errorMessage: '',
      categoryField: '',
      categoryFieldError: false,
      listData: [],
      newCategory: '',
      editedCategory: '',
      deleteCategory: '',
      categoryId: '',
      accessRights: '',
      systemSettings: '0',
      newVal: '0',
      userCategories: '0',
      consultantFunctions: '0',
      consultantCategories: '0',
      users: '0',
      classifications: '0',
      branches: '0',
      theme: '0',
      countries: '0',
      publicHolidays: '0',
      customers: '0',
      projectsBaseDataOwn: '0',
      projectsSettingOwn: '0',
      projectsFeeOwn: '0',
      projectsCapacityOwn: '0',
      projectsConsultantsOwn: '0',
      projectsInvoicesOwn: '0',
      projectsBasedataForOther: '0',
      projectsSettingOther: '0',
      projectsFeeOther: '0',
      projectsCapacityOther: '0',
      projectsConsultantsOther: '0',
      projectsInvoicesOther: '0',
      projectActivityOwn: '0',
      projectActivityOther: '0',
      projectPlanningForOwn: '0',
      projectPlanningForOther: '0',
      project_planning_all_over: '0',
      leads: '0',
      timeRegistrationOwn: '0',
      timeRegistrationOther: '0',
      monthsPlan: '0',
      consultantPlan: '0',
      consultantPlanOwn: '0',
      yearOverviewCustomers: '0',
      yearOverviewProjects: '0',
      yearOverviewConsultants: '0',
      yearOverviewStudents: '0',
      yearOverviewThemes: '0',
      yearOverviewLeads: '0',
      vacationOverview: '0',
      ressourcePlanning: '0',
      archive: '0',
      errorField: false,
      isBlocking: false,
    }
    this.baseState = this.state;
    this.textInput = React.createRef();

  }

  focusTextInput = () => {
    const access_rights = JSON.parse(localStorage.getItem('access_right'))
    const token = localStorage.getItem('access-token')

    if (Number(access_rights.user_categories) === 2 && token !== null)
      this.textInput.current.focus();
  }

  componentDidMount = () => {
    const { GetCategories } = this.props
    GetCategories()
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const { categories_list, access_rights, access_error, error_validation, new_category, edited_category, message_valid, delete_success } = this.props
    const { categoryId, editedCategory } = this.state
    if (nextProps.categories_list !== categories_list) {
      this.setState({ listData: nextProps.categories_list })
    }
    if (nextProps.edited_category !== edited_category) {
      this.setState({ editedCategory: nextProps.edited_category, isBlocking: false, })
    }
    if (nextProps.new_category !== new_category) {
      this.setState({ newCategory: nextProps.new_category, isBlocking: false, categoryId: nextProps.new_category.id, editMode: true })
    }
    if (nextProps.error_validation !== error_validation || nextProps.message_valid !== message_valid) {
      this.setState({ errorMessage: nextProps.error_validation, errorField: true })
    }
    if (nextProps.access_rights !== access_rights) {
      this.setState({
        categoryField: nextProps.access_rights.name,
        categoryId: nextProps.access_rights.id,
        accessRights: nextProps.access_rights.access_right,
        systemSettings: nextProps.access_rights.access_right.system_settings,
        userCategories: nextProps.access_rights.access_right.user_categories,
        consultantFunctions: nextProps.access_rights.access_right.consultant_functions,
        consultantCategories: nextProps.access_rights.access_right.consultant_categories,
        users: nextProps.access_rights.access_right.users,
        classifications: nextProps.access_rights.access_right.classifications,
        branches: nextProps.access_rights.access_right.branches,
        theme: nextProps.access_rights.access_right.themes,
        countries: nextProps.access_rights.access_right.countries,
        publicHolidays: nextProps.access_rights.access_right.public_holidays,
        customers: nextProps.access_rights.access_right.customers,
        projectsBaseDataOwn: nextProps.access_rights.access_right.projects_basedata_for_own,
        projectsSettingOwn: nextProps.access_rights.access_right.projects_setting_for_own,
        projectsFeeOwn: nextProps.access_rights.access_right.projects_fee_for_own,
        projectsCapacityOwn: nextProps.access_rights.access_right.projects_capacity_for_own,
        projectsConsultantsOwn: nextProps.access_rights.access_right.projects_consultants_for_own,
        projectsInvoicesOwn: nextProps.access_rights.access_right.projects_invoices_for_own,
        projectsBasedataForOther: nextProps.access_rights.access_right.projects_basedata_for_other,
        projectsSettingOther: nextProps.access_rights.access_right.projects_setting_for_other,
        projectsFeeOther: nextProps.access_rights.access_right.projects_fee_for_other,
        projectsCapacityOther: nextProps.access_rights.access_right.projects_capacity_for_other,
        projectsConsultantsOther: nextProps.access_rights.access_right.projects_consultants_for_other,
        projectsInvoicesOther: nextProps.access_rights.access_right.projects_invoices_for_other,
        projectActivityOwn: nextProps.access_rights.access_right.projects_activity_for_own,
        projectActivityOther: nextProps.access_rights.access_right.projects_activity_for_other,
        projectPlanningForOwn: nextProps.access_rights.access_right.projects_planning_for_own,
        projectPlanningForOther: nextProps.access_rights.access_right.projects_planning_for_other,
        project_planning_all_over: nextProps.access_rights.access_right.project_planning_all_over,
        leads: nextProps.access_rights.access_right.leads,
        timeRegistrationOwn: nextProps.access_rights.access_right.time_reg_for_own,
        timeRegistrationOther: nextProps.access_rights.access_right.time_reg_other_consultants_other,
        monthsPlan: nextProps.access_rights.access_right.months_plan,
        consultantPlan: nextProps.access_rights.access_right.consultant_plan,
        consultantPlanOwn: nextProps.access_rights.access_right.consultant_plan_for_own,
        yearOverviewCustomers: nextProps.access_rights.access_right.year_overview_customers,
        yearOverviewProjects: nextProps.access_rights.access_right.year_overview_projects,
        yearOverviewConsultants: nextProps.access_rights.access_right.year_overview_consultants,
        yearOverviewStudents: nextProps.access_rights.access_right.year_overview_students,
        yearOverviewThemes: nextProps.access_rights.access_right.year_overview_themes,
        yearOverviewLeads: nextProps.access_rights.access_right.year_overview_leads,
        vacationOverview: nextProps.access_rights.access_right.year_overview_vacation,
        ressourcePlanning: nextProps.access_rights.access_right.year_overview_resource_planning,
        archive: nextProps.access_rights.access_right.archive,
      })
    }
    if (nextProps.delete_success !== delete_success) {
      this.baseState.useRadioButton = false
      this.baseState.editedCategory = editedCategory
      this.baseState.deleteCategory = categoryId
      this.setState(this.baseState)
    }
    if (nextProps.access_error !== access_error) {
      this.setState({ accessErrorDialog: true })
    }
  }

  accessRightSetToBack = () => {
    const { access_rights } = this.props
    this.setState({
      isUpdateAccessDialog: false,
      categoryField: access_rights.name,
      categoryId: access_rights.id,
      accessRights: access_rights.access_right,
      systemSettings: access_rights.access_right.system_settings,
      userCategories: access_rights.access_right.user_categories,
      consultantFunctions: access_rights.access_right.consultant_functions,
      consultantCategories: access_rights.access_right.consultant_categories,
      users: access_rights.access_right.users,
      classifications: access_rights.access_right.classifications,
      branches: access_rights.access_right.branches,
      theme: access_rights.access_right.themes,
      countries: access_rights.access_right.countries,
      publicHolidays: access_rights.access_right.public_holidays,
      customers: access_rights.access_right.customers,
      projectsBaseDataOwn: access_rights.access_right.projects_basedata_for_own,
      projectsSettingOwn: access_rights.access_right.projects_setting_for_own,
      projectsFeeOwn: access_rights.access_right.projects_fee_for_own,
      projectsCapacityOwn: access_rights.access_right.projects_capacity_for_own,
      projectsConsultantsOwn: access_rights.access_right.projects_consultants_for_own,
      projectsInvoicesOwn: access_rights.access_right.projects_invoices_for_own,
      projectsBasedataForOther: access_rights.access_right.projects_basedata_for_other,
      projectsSettingOther: access_rights.access_right.projects_setting_for_other,
      projectsFeeOther: access_rights.access_right.projects_fee_for_other,
      projectsCapacityOther: access_rights.access_right.projects_capacity_for_other,
      projectsConsultantsOther: access_rights.access_right.projects_consultants_for_other,
      projectsInvoicesOther: access_rights.access_right.projects_invoices_for_other,
      projectActivityOwn: access_rights.access_right.projects_activity_for_own,
      projectActivityOther: access_rights.access_right.projects_activity_for_other,
      projectPlanningForOwn: access_rights.access_right.projects_planning_for_own,
      projectPlanningForOther: access_rights.access_right.projects_planning_for_other,
      project_planning_all_over: access_rights.access_right.project_planning_all_over,
      leads: access_rights.access_right.leads,
      timeRegistrationOwn: access_rights.access_right.time_reg_for_own,
      timeRegistrationOther: access_rights.access_right.time_reg_other_consultants_other,
      monthsPlan: access_rights.access_right.months_plan,
      consultantPlan: access_rights.access_right.consultant_plan,
      consultantPlanOwn: access_rights.access_right.consultant_plan_for_own,
      yearOverviewCustomers: access_rights.access_right.year_overview_customers,
      yearOverviewProjects: access_rights.access_right.year_overview_projects,
      yearOverviewConsultants: access_rights.access_right.year_overview_consultants,
      yearOverviewStudents: access_rights.access_right.year_overview_students,
      yearOverviewThemes: access_rights.access_right.year_overview_themes,
      yearOverviewLeads: access_rights.access_right.year_overview_leads,
      vacationOverview: access_rights.access_right.vacation_overview,
      ressourcePlanning: access_rights.access_right.year_overview_resource_planning,
      archive: access_rights.access_right.archive,
    })
  }

  getAccessRights = (item) => {
    const { GetAccessRights } = this.props
    const { isBlocking } = this.state
    if (!isBlocking) {
      GetAccessRights(item.id);
      this.setState({ useRadioButton: true, isBlocking: false, errorMessage: '', errorField: false, editMode: true })
      setTimeout(() => {
        this.focusTextInput()
      }, 200)
    } else {
      let retVal = window.confirm("Ihre Änderungen wurden nicht gepeichert. Möchten Sie trotzdem fortfahren?");

      if (retVal === true) {
        this.setState({ isBlocking: false }, () => this.getAccessRights(item))
      } else {
        this.setState({ isBlocking: false }, () => setTimeout(() => {
          this.setState({ isBlocking: true })
        }, 1000))
      }
    }
  }


  resetForm = () => {
    const { categories_list } = this.props
    const { editedCategory } = this.state
    this.baseState.useRadioButton = true
    this.baseState.listData = categories_list
    this.baseState.editedCategory = editedCategory
    this.setState(this.baseState)
    setTimeout(() => {
      this.focusTextInput()
    }, 400)
  }

  render() {
    const {
      isDeleteContactDialogOpen,
      editMode,
      listData,
      useRadioButton,
      systemSettings,
      userCategories,
      consultantFunctions,
      consultantCategories,
      users,
      classifications,
      branches,
      theme,
      countries,
      publicHolidays,
      customers,
      projectsBaseDataOwn,
      projectsSettingOwn,
      projectsFeeOwn,
      projectsCapacityOwn,
      projectsConsultantsOwn,
      projectsInvoicesOwn,
      projectsBasedataForOther,
      projectsSettingOther,
      projectsFeeOther,
      projectsCapacityOther,
      projectsConsultantsOther,
      projectsInvoicesOther,
      projectActivityOwn,
      projectActivityOther,
      projectPlanningForOwn,
      projectPlanningForOther,
      timeRegistrationOwn,
      timeRegistrationOther,
      leads,
      monthsPlan,
      consultantPlan,
      consultantPlanOwn,
      yearOverviewCustomers,
      yearOverviewProjects,
      yearOverviewConsultants,
      yearOverviewStudents,
      yearOverviewThemes,
      yearOverviewLeads,
      archive,
      categoryField,
      errorMessage,
      errorField,
      editedCategory,
      project_planning_all_over,
      vacationOverview,
      ressourcePlanning,
      deleteCategory,
      newCategory, accessErrorDialog, isUpdateAccessDialog, isBlocking } = this.state
    const { isloading, access_error } = this.props
    const access_rights = JSON.parse(localStorage.getItem('access_right'))
    const token = localStorage.getItem('access-token')
    if (token === null) {
      this.props.LogoutAction()
    }
    return (
      <div>
        {isloading && <OverLoader />}
        <Container maxWidth="xl">
          <Grid container spacing={3} className="mainBlock">
            {isEmpty(errorMessage.message) ?
              <Fragment>
                <Grid item md={3} sm={4} xs={12}>
                  <div className="leftSide">
                    <SideSearchbar
                      tittle={"Neue Kategorie"}
                      listData={listData}
                      newList={newCategory}
                      editedList={editedCategory}
                      deleteList={deleteCategory}
                      getDataOfSelectedItemFunc={this.getAccessRights}
                      createNewListFunc={this.resetForm}
                      isRight={Number(access_rights.user_categories)}

                    />
                  </div>
                </Grid>
                <Grid item md={9} sm={8} xs={12}
                  className={`${Number(access_rights.user_categories) === 1 ? "disableALlFields" : ""}`}
                >
                  <Prompt
                    when={isBlocking}
                    message={location =>
                      `Ihre Änderungen wurden nicht gepeichert. Möchten Sie trotzdem fortfahren? `
                    }
                  />
                  <div className="rightBlock liproCard" >
                    <div className="mb2">
                      <span style={{
                        display: 'inline-flex',
                        padding: '10px 10px 10px 0',
                      }}>Kategorie</span>
                      <TextField
                        helperText={errorField ? "Kategorie " + errorMessage.name : ''} error={errorField ? true : false}
                        inputRef={this.textInput}
                        value={categoryField} disabled={useRadioButton ? false : true} onChange={(e) => {
                          this.setState({ categoryField: e.target.value, errorField: false, isBlocking: true })
                        }} variant="outlined"
                        className="innerInput" />
                    </div>
                    <div className="mb2 usercategoryTable">
                      <label className="mb1">Zugriffsrechte</label>
                      <TableContainer component={Paper}>
                        <Table aria-label="simple table">
                          <TableHead>
                            <TableRow>
                              <TableCell>Funktionen</TableCell>
                              <TableCell align="center" colSpan={3}>Eigene Projekte</TableCell>
                              <TableCell align="center" colSpan={3} className="br-0">Alle Projekte</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            <TableRow>
                              <TableCell component="th" scope="row">
                                Berechtigung
                          </TableCell>
                              <TableCell align="center">Keine</TableCell>
                              <TableCell align="center">Lesen</TableCell>
                              <TableCell align="center">Ändern</TableCell>
                              <TableCell align="center">Keine</TableCell>
                              <TableCell align="center">Lesen</TableCell>
                              <TableCell align="center">Ändern</TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell component="th" scope="row">
                                Systemeinstellungen
                          </TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center" colSpan="3" className="zeroPadded">
                                <RadioGroup name="system_settings" value={systemSettings} onChange={(e) => this.setState({ systemSettings: e.target.value, isBlocking: true })}>
                                  <Table aria-label="simple table">
                                    <TableBody>
                                      <TableRow>
                                        <TableCell align="center"><FormControlLabel value="0" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="1" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="2" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </RadioGroup>
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell component="th" scope="row">
                                Benutzerkategorien
                          </TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center" colSpan="3" className="zeroPadded">
                                <RadioGroup name="system_settings" value={userCategories} onChange={(e) => this.setState({ userCategories: e.target.value, isBlocking: true })}>
                                  <Table aria-label="simple table">
                                    <TableBody>
                                      <TableRow>
                                        <TableCell align="center"><FormControlLabel value="0" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="1" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="2" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </RadioGroup>
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell component="th" scope="row">
                                Beraterfunktionen
                          </TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center" colSpan="3" className="zeroPadded">
                                <RadioGroup name="system_settings" value={consultantFunctions} onChange={(e) => this.setState({ consultantFunctions: e.target.value, isBlocking: true })}>
                                  <Table aria-label="simple table">
                                    <TableBody>
                                      <TableRow>
                                        <TableCell align="center"><FormControlLabel value="0" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="1" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="2" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </RadioGroup>
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell component="th" scope="row">
                                Benutzer
                          </TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center" colSpan="3" className="zeroPadded">
                                <RadioGroup name="system_settings" value={users} onChange={(e) => this.setState({ users: e.target.value, isBlocking: true })}>
                                  <Table aria-label="simple table">
                                    <TableBody>
                                      <TableRow>
                                        <TableCell align="center"><FormControlLabel value="0" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="1" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="2" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </RadioGroup>
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell component="th" scope="row">
                                Benutzer, Zugriffsrechte
                          </TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center" colSpan="3" className="zeroPadded">
                                <RadioGroup name="system_settings" value={consultantCategories} onChange={(e) => this.setState({ consultantCategories: e.target.value, isBlocking: true })}>
                                  <Table aria-label="simple table">
                                    <TableBody>
                                      <TableRow>
                                        <TableCell align="center"><FormControlLabel value="0" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="1" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="2" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </RadioGroup>
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell component="th" scope="row">
                                Einstufungen
                          </TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center" colSpan="3" className="zeroPadded">
                                <RadioGroup name="system_settings" value={classifications} onChange={(e) => this.setState({ classifications: e.target.value, isBlocking: true })}>
                                  <Table aria-label="simple table">
                                    <TableBody>
                                      <TableRow>
                                        <TableCell align="center"><FormControlLabel value="0" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="1" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="2" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </RadioGroup>
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell component="th" scope="row">
                                Branchen
                          </TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center" colSpan="3" className="zeroPadded">
                                <RadioGroup name="system_settings" value={branches} onChange={(e) => this.setState({ branches: e.target.value, isBlocking: true })}>
                                  <Table aria-label="simple table">
                                    <TableBody>
                                      <TableRow>
                                        <TableCell align="center"><FormControlLabel value="0" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="1" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="2" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </RadioGroup>
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell component="th" scope="row">
                                Themen
                          </TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center" colSpan="3" className="zeroPadded">
                                <RadioGroup name="system_settings" value={theme} onChange={(e) => this.setState({ theme: e.target.value, isBlocking: true })}>
                                  <Table aria-label="simple table">
                                    <TableBody>
                                      <TableRow>
                                        <TableCell align="center"><FormControlLabel value="0" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="1" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="2" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </RadioGroup>
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell component="th" scope="row">
                                Länder
                          </TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center" colSpan="3" className="zeroPadded">
                                <RadioGroup name="system_settings" value={countries} onChange={(e) => this.setState({ countries: e.target.value, isBlocking: true })}>
                                  <Table aria-label="simple table">
                                    <TableBody>
                                      <TableRow>
                                        <TableCell align="center"><FormControlLabel value="0" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="1" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="2" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </RadioGroup>
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell component="th" scope="row">
                                Feiertage
                          </TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center" colSpan="3" className="zeroPadded">
                                <RadioGroup name="system_settings" value={publicHolidays} onChange={(e) => this.setState({ publicHolidays: e.target.value, isBlocking: true })}>
                                  <Table aria-label="simple table">
                                    <TableBody>
                                      <TableRow>
                                        <TableCell align="center"><FormControlLabel value="0" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="1" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="2" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </RadioGroup>
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell component="th" scope="row">
                                Kunden
                          </TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center" colSpan="3" className="zeroPadded">
                                <RadioGroup name="system_settings" value={customers} onChange={(e) => this.setState({ customers: e.target.value, isBlocking: true })}>
                                  <Table aria-label="simple table">
                                    <TableBody>
                                      <TableRow>
                                        <TableCell align="center"><FormControlLabel value="0" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="1" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="2" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </RadioGroup>
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell component="th" scope="row">
                                Projekte, Planung überall
                          </TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center" colSpan="3" className="zeroPadded">
                                <RadioGroup name="system_settings" value={project_planning_all_over} onChange={(e) => this.setState({ project_planning_all_over: e.target.value, isBlocking: true })}>
                                  <Table aria-label="simple table">
                                    <TableBody>
                                      <TableRow>
                                        <TableCell align="center"><FormControlLabel value="0" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"></TableCell>
                                        <TableCell align="center"><FormControlLabel value="1" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </RadioGroup>
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell component="th" scope="row">
                                Projekte, Stammdaten
                          </TableCell>
                              <TableCell align="center" colSpan="3" className="zeroPadded">
                                <RadioGroup name="system_settings" value={projectsBaseDataOwn} onChange={(e) => this.setState({ projectsBaseDataOwn: e.target.value, isBlocking: true })}>
                                  <Table aria-label="simple table">
                                    <TableBody>
                                      <TableRow>
                                        <TableCell align="center"><FormControlLabel value="0" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="1" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="2" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </RadioGroup>
                              </TableCell>
                              <TableCell align="center" colSpan="3" className="zeroPadded">
                                <RadioGroup name="system_settings" value={projectsBasedataForOther} onChange={(e) => this.setState({ projectsBasedataForOther: e.target.value, isBlocking: true })}>
                                  <Table aria-label="simple table">
                                    <TableBody>
                                      <TableRow>
                                        <TableCell align="center"><FormControlLabel value="0" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="1" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="2" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </RadioGroup>
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell component="th" scope="row">
                                Projekte, auf 100% setzen
                          </TableCell>
                              <TableCell align="center" colSpan="3" className="zeroPadded">
                                <RadioGroup name="system_settings" value={projectsSettingOwn} onChange={(e) => this.setState({ projectsSettingOwn: e.target.value, isBlocking: true })}>
                                  <Table aria-label="simple table">
                                    <TableBody>
                                      <TableRow>
                                        <TableCell align="center"></TableCell>
                                        <TableCell align="center"><FormControlLabel value="1" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="2" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </RadioGroup>
                              </TableCell><TableCell align="center" colSpan="3" className="zeroPadded">
                                <RadioGroup name="system_settings" value={projectsSettingOther} onChange={(e) => this.setState({ projectsSettingOther: e.target.value, isBlocking: true })}>
                                  <Table aria-label="simple table">
                                    <TableBody>
                                      <TableRow>
                                        <TableCell align="center"></TableCell>
                                        <TableCell align="center"><FormControlLabel value="1" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="2" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </RadioGroup>
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell component="th" scope="row">
                                Projekte, Honorar
                          </TableCell>
                              <TableCell align="center" colSpan="3" className="zeroPadded">
                                <RadioGroup name="system_settings" value={projectsFeeOwn} onChange={(e) => this.setState({ projectsFeeOwn: e.target.value, isBlocking: true })}>
                                  <Table aria-label="simple table">
                                    <TableBody>
                                      <TableRow>
                                        <TableCell align="center"><FormControlLabel value="0" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="1" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="2" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </RadioGroup>
                              </TableCell><TableCell align="center" colSpan="3" className="zeroPadded">
                                <RadioGroup name="system_settings" value={projectsFeeOther} onChange={(e) => this.setState({ projectsFeeOther: e.target.value, isBlocking: true })}>
                                  <Table aria-label="simple table">
                                    <TableBody>
                                      <TableRow>
                                        <TableCell align="center"><FormControlLabel value="0" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="1" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="2" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </RadioGroup>
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell component="th" scope="row">
                                Projekte, Kapazität
                          </TableCell>
                              <TableCell align="center" colSpan="3" className="zeroPadded">
                                <RadioGroup name="system_settings" value={projectsCapacityOwn} onChange={(e) => this.setState({ projectsCapacityOwn: e.target.value, isBlocking: true })}>
                                  <Table aria-label="simple table">
                                    <TableBody>
                                      <TableRow>
                                        <TableCell align="center"><FormControlLabel value="0" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="1" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="2" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </RadioGroup>
                              </TableCell><TableCell align="center" colSpan="3" className="zeroPadded">
                                <RadioGroup name="system_settings" value={projectsCapacityOther} onChange={(e) => this.setState({ projectsCapacityOther: e.target.value, isBlocking: true })}>
                                  <Table aria-label="simple table">
                                    <TableBody>
                                      <TableRow>
                                        <TableCell align="center"><FormControlLabel value="0" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="1" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="2" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </RadioGroup>
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell component="th" scope="row">
                                Projekte, Berater
                          </TableCell>
                              <TableCell align="center" colSpan="3" className="zeroPadded">
                                <RadioGroup name="system_settings" value={projectsConsultantsOwn} onChange={(e) => this.setState({ projectsConsultantsOwn: e.target.value, isBlocking: true })}>
                                  <Table aria-label="simple table">
                                    <TableBody>
                                      <TableRow>
                                        <TableCell align="center"><FormControlLabel value="0" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="1" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="2" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </RadioGroup>
                              </TableCell>
                              <TableCell align="center" colSpan="3" className="zeroPadded">
                                <RadioGroup name="system_settings" value={projectsConsultantsOther} onChange={(e) => this.setState({ projectsConsultantsOther: e.target.value, isBlocking: true })}>
                                  <Table aria-label="simple table">
                                    <TableBody>
                                      <TableRow>
                                        <TableCell align="center"><FormControlLabel value="0" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="1" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="2" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </RadioGroup>
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell component="th" scope="row">
                                Projekte, Planung
                          </TableCell>
                              <TableCell align="center" colSpan="3" className="zeroPadded">
                                <RadioGroup name="system_settings" value={projectPlanningForOwn} onChange={(e) => this.setState({ projectPlanningForOwn: e.target.value, isBlocking: true })}>
                                  <Table aria-label="simple table">
                                    <TableBody>
                                      <TableRow>
                                        <TableCell align="center"><FormControlLabel value="0" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="1" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="2" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </RadioGroup>
                              </TableCell>
                              <TableCell align="center" colSpan="3" className="zeroPadded">
                                <RadioGroup name="system_settings" value={projectPlanningForOther} onChange={(e) => this.setState({ projectPlanningForOther: e.target.value, isBlocking: true })}>
                                  <Table aria-label="simple table">
                                    <TableBody>
                                      <TableRow>
                                        <TableCell align="center"><FormControlLabel value="0" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="1" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="2" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </RadioGroup>
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell component="th" scope="row">
                                Projekte, Rechnungen
                          </TableCell>
                              <TableCell align="center" colSpan="3" className="zeroPadded">
                                <RadioGroup name="system_settings" value={projectsInvoicesOwn} onChange={(e) => this.setState({ projectsInvoicesOwn: e.target.value, isBlocking: true })}>
                                  <Table aria-label="simple table">
                                    <TableBody>
                                      <TableRow>
                                        <TableCell align="center"><FormControlLabel value="0" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="1" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="2" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </RadioGroup>
                              </TableCell>
                              <TableCell align="center" colSpan="3" className="zeroPadded">
                                <RadioGroup name="system_settings" value={projectsInvoicesOther} onChange={(e) => this.setState({ projectsInvoicesOther: e.target.value, isBlocking: true })}>
                                  <Table aria-label="simple table">
                                    <TableBody>
                                      <TableRow>
                                        <TableCell align="center"><FormControlLabel value="0" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="1" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="2" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </RadioGroup>
                              </TableCell>
                            </TableRow>
                            {/* <TableRow>
                              <TableCell component="th" scope="row">
                                Projekte, Tätigkeiten
                          </TableCell>
                              <TableCell align="center" colSpan="3" className="zeroPadded">
                                <RadioGroup name="system_settings" value={projectActivityOwn} onChange={(e) => this.setState({ projectActivityOwn: e.target.value,isBlocking: true })}>
                                  <Table aria-label="simple table">
                                    <TableBody>
                                      <TableRow>
                                        <TableCell align="center"><FormControlLabel value="0" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="1" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="2" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </RadioGroup>
                              </TableCell>
                              <TableCell align="center" colSpan="3" className="zeroPadded">
                                <RadioGroup name="system_settings" value={projectActivityOther} onChange={(e) => this.setState({ projectActivityOther: e.target.value,isBlocking: true })}>
                                  <Table aria-label="simple table">
                                    <TableBody>
                                      <TableRow>
                                        <TableCell align="center"><FormControlLabel value="0" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="1" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="2" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </RadioGroup>
                              </TableCell>
                            </TableRow> */}
                            <TableRow>
                              <TableCell component="th" scope="row">
                                Stundenerfassung
                          </TableCell>
                              <TableCell align="center" colSpan="3" className="zeroPadded">
                                <RadioGroup name="system_settings" value={timeRegistrationOwn} onChange={(e) => this.setState({ timeRegistrationOwn: e.target.value, isBlocking: true })}>
                                  <Table aria-label="simple table">
                                    <TableBody>
                                      <TableRow>
                                        <TableCell align="center"><FormControlLabel value="0" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="1" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="2" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </RadioGroup>
                              </TableCell>
                              <TableCell align="center" colSpan="3" className="zeroPadded">
                                <RadioGroup name="system_settings" value={timeRegistrationOther} onChange={(e) => this.setState({ timeRegistrationOther: e.target.value, isBlocking: true })}>
                                  <Table aria-label="simple table">
                                    <TableBody>
                                      <TableRow>
                                        <TableCell align="center"><FormControlLabel value="0" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="1" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="2" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </RadioGroup>
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell component="th" scope="row">
                                Akquiseliste
                          </TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center" colSpan="3" className="zeroPadded">
                                <RadioGroup name="system_settings" value={leads} onChange={(e) => this.setState({ leads: e.target.value, isBlocking: true })}>
                                  <Table aria-label="simple table">
                                    <TableBody>
                                      <TableRow>
                                        <TableCell align="center"><FormControlLabel value="0" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="1" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="2" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </RadioGroup>
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell component="th" scope="row">
                                6-Monatsplan
                          </TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center" colSpan="3" className="zeroPadded">
                                <RadioGroup name="system_settings" value={monthsPlan} onChange={(e) => this.setState({ monthsPlan: e.target.value, isBlocking: true })}>
                                  <Table aria-label="simple table">
                                    <TableBody>
                                      <TableRow>
                                        <TableCell align="center"><FormControlLabel value="0" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="1" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"></TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </RadioGroup>
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell component="th" scope="row">
                                Beraterplan
                          </TableCell>
                              <TableCell align="center" colSpan="3" className="zeroPadded">
                                <RadioGroup name="system_settings" value={consultantPlanOwn} onChange={(e) => this.setState({ consultantPlanOwn: e.target.value, isBlocking: true })}>
                                  <Table aria-label="simple table">
                                    <TableBody>
                                      <TableRow>
                                        <TableCell align="center"><FormControlLabel value="0" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="1" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"></TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </RadioGroup>
                              </TableCell>
                              <TableCell align="center" colSpan="3" className="zeroPadded">
                                <RadioGroup name="system_settings" value={consultantPlan} onChange={(e) => this.setState({ consultantPlan: e.target.value, isBlocking: true })}>
                                  <Table aria-label="simple table">
                                    <TableBody>
                                      <TableRow>
                                        <TableCell align="center"><FormControlLabel value="0" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="1" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"></TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </RadioGroup>
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell component="th" scope="row">
                                Jahresübersicht Kunden
                          </TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center" colSpan="3" className="zeroPadded">
                                <RadioGroup name="system_settings" value={yearOverviewCustomers} onChange={(e) => this.setState({ yearOverviewCustomers: e.target.value, isBlocking: true })}>
                                  <Table aria-label="simple table">
                                    <TableBody>
                                      <TableRow>
                                        <TableCell align="center"><FormControlLabel value="0" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="1" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"></TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </RadioGroup>
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell component="th" scope="row">
                                Jahresübersicht Projekte
                          </TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center" colSpan="3" className="zeroPadded">
                                <RadioGroup name="system_settings" value={yearOverviewProjects} onChange={(e) => this.setState({ yearOverviewProjects: e.target.value, isBlocking: true })}>
                                  <Table aria-label="simple table">
                                    <TableBody>
                                      <TableRow>
                                        <TableCell align="center"><FormControlLabel value="0" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="1" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"></TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </RadioGroup>
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell component="th" scope="row">
                                Jahresübersicht Berater
                          </TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center" colSpan="3" className="zeroPadded">
                                <RadioGroup name="system_settings" value={yearOverviewConsultants} onChange={(e) => this.setState({ yearOverviewConsultants: e.target.value, isBlocking: true })}>
                                  <Table aria-label="simple table">
                                    <TableBody>
                                      <TableRow>
                                        <TableCell align="center"><FormControlLabel value="0" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="1" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"></TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </RadioGroup>
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell component="th" scope="row">
                              Jahresübersicht Studenten
                          </TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center" colSpan="3" className="zeroPadded">
                                <RadioGroup name="system_settings" value={yearOverviewStudents} onChange={(e) => this.setState({ yearOverviewStudents: e.target.value, isBlocking: true })}>
                                  <Table aria-label="simple table">
                                    <TableBody>
                                      <TableRow>
                                        <TableCell align="center"><FormControlLabel value="0" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="1" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"></TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </RadioGroup>
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell component="th" scope="row">
                                Jahresübersicht Themen
                          </TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center" colSpan="3" className="zeroPadded">
                                <RadioGroup name="system_settings" value={yearOverviewThemes} onChange={(e) => this.setState({ yearOverviewThemes: e.target.value, isBlocking: true })}>
                                  <Table aria-label="simple table">
                                    <TableBody>
                                      <TableRow>
                                        <TableCell align="center"><FormControlLabel value="0" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="1" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"></TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </RadioGroup>
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell component="th" scope="row">
                                Jahresübersicht Leads
                          </TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center" colSpan="3" className="zeroPadded">
                                <RadioGroup name="system_settings" value={yearOverviewLeads} onChange={(e) => this.setState({ yearOverviewLeads: e.target.value, isBlocking: true })}>
                                  <Table aria-label="simple table">
                                    <TableBody>
                                      <TableRow>
                                        <TableCell align="center"><FormControlLabel value="0" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="1" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"></TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </RadioGroup>
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell component="th" scope="row">
                                Urlaubsübersicht
                          </TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center" colSpan="3" className="zeroPadded">
                                <RadioGroup name="system_settings" value={vacationOverview} onChange={(e) => this.setState({ vacationOverview: e.target.value, isBlocking: true })}>
                                  <Table aria-label="simple table">
                                    <TableBody>
                                      <TableRow>
                                        <TableCell align="center"><FormControlLabel value="0" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="1" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"></TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </RadioGroup>
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell component="th" scope="row">
                                Ressourcenplanung
                          </TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center" colSpan="3" className="zeroPadded">
                                <RadioGroup name="system_settings" value={ressourcePlanning} onChange={(e) => this.setState({ ressourcePlanning: e.target.value, isBlocking: true })}>
                                  <Table aria-label="simple table">
                                    <TableBody>
                                      <TableRow>
                                        <TableCell align="center"><FormControlLabel value="0" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="1" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"></TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </RadioGroup>
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell component="th" scope="row">
                                Archiv
                          </TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center"></TableCell>
                              <TableCell align="center" colSpan="3" className="zeroPadded">
                                <RadioGroup name="system_settings" value={archive} onChange={(e) => this.setState({ archive: e.target.value, isBlocking: true })}>
                                  <Table aria-label="simple table">
                                    <TableBody>
                                      <TableRow>
                                        <TableCell align="center"><FormControlLabel value="0" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"><FormControlLabel value="1" disabled={useRadioButton ? false : true} control={<Radio />} /></TableCell>
                                        <TableCell align="center"></TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </RadioGroup>
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>
                      {Number(access_rights.user_categories) !== 1 &&
                        <div className="actionBtn">
                          {editMode ?
                            <Fragment>
                              <Button variant="outlined" color="primary" onClick={() => { this.setState({ isUpdateAccessDialog: true }) }} >Speichern</Button>
                              <Button variant="outlined" color="primary" onClick={() => { this.openDeleteDialog() }} >Löschen</Button>
                              <Button variant="outlined" color="secondary" disabled={useRadioButton ? false : true} onClick={() => { this.AbortAdding() }} >Abbrechen</Button>
                            </Fragment>
                            :
                            <Button variant="outlined" color="primary" disabled={useRadioButton ? false : true} onClick={() => { this.createCategory() }} >Hinzufügen</Button>
                          }
                        </div>
                      }
                      <Dialog
                        open={isDeleteContactDialogOpen}
                      >
                        <DialogTitle>Benutzerkategorien löschen</DialogTitle>
                        <DialogContent>
                          <DialogContentText >
                            Sind Sie sicher?
              </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                          <Button onClick={this.deleteCategory} size="small" variant="outlined" color="primary" autoFocus>
                            Bestätigen
                      </Button>
                          <Button onClick={this.closeDeleteContactDialog} size="small" variant="outlined" color="secondary" >
                            Abbrechen
                        </Button>
                        </DialogActions>
                      </Dialog>

                      <Dialog
                        open={isUpdateAccessDialog}
                      >
                        <DialogContent>
                          <DialogContentText >
                            Bitte beachten Sie, dass die Zugriffsrechte der aktuellen Benutzer nicht automatisch angepasst werden
              </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                          <Button onClick={this.editCategory} size="small" variant="outlined" color="primary" autoFocus>
                            Bestätigen
                      </Button>
                          <Button onClick={this.accessRightSetToBack} size="small" variant="outlined" color="secondary" >
                            Abbrechen
                        </Button>
                        </DialogActions>
                      </Dialog>

                      <Dialog
                        open={accessErrorDialog}
                      >
                        <DialogTitle>Systemeinstellungen</DialogTitle>
                        <DialogContent>
                          <DialogContentText >
                            {access_error && access_error.message}
                          </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                          <Button onClick={() => this.setState({ accessErrorDialog: false })} size="small" variant="outlined" color="secondary" >
                            Abbrechen
              </Button>
                        </DialogActions>
                      </Dialog>
                    </div>
                  </div>
                </Grid>
              </Fragment>
              :
              <Grid item md={12} sm={12} xs={12}>
                <div className="rightBlock rightBlock-bgWhite user-system">
                  <h3>{errorMessage.message}</h3>
                </div>
              </Grid>
            }
          </Grid>
        </Container>

      </div>
    )
  }

  deleteCategory = () => {
    const { DeleteCategory } = this.props
    const { categoryId } = this.state
    DeleteCategory(categoryId)
    this.setState({ isDeleteContactDialogOpen: false })
  }

  openDeleteDialog = () => {
    this.setState({ isDeleteContactDialogOpen: true })
  }
  closeDeleteContactDialog = () => {
    this.setState({ isDeleteContactDialogOpen: false })
  }
  AbortAdding = () => {
    const { editedCategory } = this.state
    this.baseState.useRadioButton = false
    this.baseState.listData = this.props.categories_list
    this.baseState.editedCategory = editedCategory
    this.setState(this.baseState)
  }

  editCategory = () => {
    const dataObj = this.state
    const { EditCategories } = this.props;
    this.setState({ isUpdateAccessDialog: false })
    EditCategories(dataObj)
  }

  createCategory = () => {
    const dataObj = this.state
    const { CreateCategories } = this.props
    CreateCategories(dataObj)
  }
}

const mapStateToProps = ({ categories }) => {
  return {
    isloading: categories.loading,
    categories_list: categories.categories_list,
    message_valid: categories.message_valid,
    access_rights: categories.access_rights,
    category_name: categories.category_name,
    edited_category: categories.edited_category,
    new_category: categories.new_category,
    delete_success: categories.success,
    error_validation: categories.error_message,
    access_error: categories.access_error,

  }
};

const mapDispatchToProps = dispatch => {
  return {
    // dispatching actions
    GetCategories: () => dispatch(GetCategories()),
    GetAccessRights: (id) => dispatch(GetAccessRights(id)),
    EditCategories: (obj) => dispatch(EditCategories(obj)),
    CreateCategories: (obj) => dispatch(CreateCategories(obj)),
    DeleteCategory: (id) => dispatch(DeleteCategory(id)),
    LogoutAction: () => dispatch(LogoutAction()),
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(UserCategories)